export interface CustomBetterStackEvent {
    event: string;
    level?: BetterStackLogLevel;
    message?: string;
    data?: Record<string, unknown>;
}

export enum BetterStackLogLevel {
    EMERGENCY = 'emerg',
    ALERT = 'alert',
    CRITICAL = 'critical',
    ERROR = 'error',
    WARNING = 'warn',
    NOTICE = 'notice',
    INFO = 'info',
    DEBUGGING = 'debug',
}

export interface BetterStackEvent {
    /**
     * Determines the log level of the event and its urgency.
     * @default 'info'
     */
    level?: BetterStackLogLevel;
    dt?: string;
    message: string;
}

export type BetterStackPayload = BetterStackEvent | BetterStackEvent[];
